const composeUrl = () => {
  const { port, protocol, hostname } = window.location;
  const url = `${protocol}//${hostname}`;

  if (port) {
    return `${url}:${port}`;
  }

  return url;
};

const getCurrentUrl = () => window.location.origin || composeUrl();
const getDomainName = () => {
  const hostName = window.location.hostname;
  return hostName.substring(
    hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
  );
};

const url = { getCurrentUrl, getDomainName };

export { url };
